import {
  buildFormDataRequest,
  buildBaseUrl,
  buildHttpResponse,
  buildMultipartHttpResponse,
  HttpMethod,
} from "./Network_utility";
import { getAccessToken } from "../pages/Protected";
import { ChartRecord, ReChartData } from "../models/chart_model";
import { AuctionChartData } from "../models/auction";
import { ApiResponse } from "../models/api_res";
import DmrcLoad, { DmrcForecastedLoad } from "../models/dmrc";
import { ProductionData, LNGImportData, PowerStationData } from "../models/gas";
import { ConsumptionData } from "../models/consumption";
import { PowerGeneration } from "../models/power_generation";
import {
  getFiscalYear,
  getMonthFromDate,
  getMonthYear,
  GetNumberOfDaysInMonth,
  getQuarter,
  getYearFromDate,
} from "../extensions/date";
import {
  convertToRajasthanGenData,
  HarayanaDailyForecastData,
  HarayanaDailyPeakData,
  HarayanaDiscomData,
  HarayanaMonthlyForecastData,
  HarayanaMonthlyPeakData,
  HarayanaWeatherData,
  HaryanaGnaTgna,
  HaryanaIsgs,
  HaryanaRemc,
  RajashtanRrvpn,
  RajasthanCollective,
  RajasthanDiscomData,
  RajasthanDiscomDrawal,
  RajasthanGenData,
  RajasthanGnaTgna,
  RajasthanIsgs,
  RajasthanUploadFile,
  RajBankingData,
  RajGenParams,
  RajGenProfile,
  RajMappings,
  RajProcurement,
  RajProcurementRecord,
  RajSurplusDeficitData,
  RajTamData,
  ReEnergyData,
} from "../models/rajasthan";
import {
  GenerationCommon,
  GridcoDiscomData,
  gridcoIsgs,
  GridoIsgs,
  IntrastateGen,
  IsgsExportJobResponse,
  PaginatedResponse,
} from "../models/gridco";
import { titleCase } from "../extensions/extension";
import { TradersData } from "../models/commonTraders";
import {
  HaryanaYearlyProcurementData,
  HaryanaMonthlyProcurementData,
  HaryanaData,
} from "../models/haryana";
import { sub } from "date-fns";
import { sl } from "date-fns/locale";
import { ExchangeMetrics, GetCollectiveMetricsParams } from "../models/metrics";
import { BankingCalculateParams, BankingCalculateResponse } from "../models/banking";
import {
  AgentEvent,
  ThumbsFeedbackResponse,
  ThumbsFeedbackResult,
} from "../models/agent";
import { GenerationData } from "../models/generationData";
import { ExchangeBidData } from "../models/exchangeBidData";
import {
  PriceAnalysisData,
  PriceAnalysisParams,
} from "../models/priceAnalysis";
import { BuyerSellerParams, BuyerSellerResponse } from "../models/buyerSeller";
import {
  ExchangeAnalysisData,
  ExchangeAnalysisParams,
} from "../pages/Dashboard/NewExchnage/Tabs/Overview";
import { getTimeRange } from "../pages/Dashboard/Exchange3/Chart";
const API_BASE =
  process.env.REACT_APP_API_BASE || "https://gnai-agent.gna.energy";

export async function login(
  email: string,
  dashboard_type?: string,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/login/",
    method: HttpMethod.POST,
    body: {
      email: email,
      dashboard_type: dashboard_type,
    },
  });
  return response as ApiResponse;
}

export async function verifyOtp(
  email: string,
  otp: string,
  dashboard_type?: string,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/verify_otp/",
    method: HttpMethod.POST,
    body: {
      email: email,
      otp: otp,
      dashboard_type: dashboard_type,
    },
  });
  return response as ApiResponse;
}

export async function checkAccess(accessKey: string): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/check_access/",
    method: HttpMethod.POST,
    body: {
      access_key: accessKey,
    },
  });
  return response as ApiResponse;
}

export async function checkAccessBulk(): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/check_access_bulk/",
    method: HttpMethod.GET,
  });
  return response as ApiResponse;
}

export async function getSessionValidity(): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: "user/get_session_validity/",
    method: HttpMethod.GET,
  });
  return response as ApiResponse;
}

export async function fetchExchangeSlotData({
  exchange,
  product,
  slot,
  date,
}: {
  exchange: string;
  product: string;
  slot: string;
  date: string;
}) {
  console.log("fetchExchangeSlotData", exchange, product, slot, date);

  // Handle case where we want to send empty time_slots array for date-only requests
  const timeSlots = slot === "no-slot" ? [] : [slot];

  const response = await buildHttpResponse({
    endPoint: "https://api-data.gna.energy/data/getTopBuySellData/",
    method: HttpMethod.POST,
    body: {
      exchanges: [exchange],
      products: [product],
      time_slots: timeSlots,
      start_date: date,
      end_date: date,
    },
  });
  return response;
}

export async function fetchExchangeComparisonData(body: any) {
  const response = await buildHttpResponse({
    endPoint: "data/multipleDateRangeExchangeData/",
    method: HttpMethod.POST,
    body: body,
  });
  return response;
}

export async function fetchAllExchangeData(
  start_date: string,
  end_date: string,
) {
  const response = await buildHttpResponse({
    endPoint: `data/getData?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getEntityComparisont({
  entityid,
  exchange,
  startDate,
  endDate,
}: {
  entityid: number;
  exchange: string;
  startDate: string;
  endDate: string;
}): Promise<ReChartData[]> {
  const response = await fetch(
    "https://api-data.gna.energy/data/getSlotWiseAggregatedEntityData/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // {
      //     "start_date": "2024-01-01",
      //     "end_date": "2024-12-31",
      //     "exchange": "IEX",
      //     "entitity_id": 3027
      // }
      body: JSON.stringify({
        start_date: startDate,
        end_date: endDate,
        exchange: exchange,
        entitity_id: entityid,
      }),
    },
  );
  // body: {
  //     'start_date': startDate,
  //     'end_date': endDate,
  //     'exchange': exchange,
  //     'entity_id': entityid
  // }
  const data = await response.json();

  return data.data as any;
}

export async function getEntitys() {
  const response = await fetch("https://api-data.gna.energy/data/getEntitys", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data: {
    data: { id: number; name: string }[];
  } = await response.json();

  const res = data.data.map((d) => {
    return {
      value: d.id,
      name: d.name,
    };
  });
  return res;
}

const fetchLatestAggregatedDayData = async () => {
  try {
    const response = await buildHttpResponse({
      endPoint: "data/latest-aggregated-day-data/",
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error("Error fetching data");
  }
};

export default fetchLatestAggregatedDayData;

export async function fetchPSPData() {
  const response = await buildHttpResponse({
    endPoint: "data/power_supply_api",
    method: HttpMethod.POST,
  });
  return response;
}

export async function fetchDailyAuctionData({
  start_date,
  end_date,
  exchange,
  entity_id,
}: {
  start_date: string;
  end_date: string;
  exchange?: string;
  entity_id?: number;
}): Promise<AuctionChartData[]> {
  const response = await buildHttpResponse({
    endPoint: `data/auction-daily-api?start_date=${start_date}&end_date=${end_date}&exchange_type=${exchange}`,
    method: HttpMethod.GET,
  });
  return response as AuctionChartData[];
}

export async function fetchMonthlyAuctionData({
  start_date,
  end_date,
  exchange,
  entity_id,
}: {
  start_date: string;
  end_date: string;
  exchange?: string;
  entity_id?: number;
}): Promise<AuctionChartData[]> {
  const response = await buildHttpResponse({
    endPoint: `data/auction-monthly-api?start_date=${start_date}&end_date=${end_date}&exchange_type=${exchange}`,
    method: HttpMethod.GET,
  });
  return response as AuctionChartData[];
}

export async function fetchSnapshots(
  start_date: string,
  end_date: string,
): Promise<ChartRecord[]> {
  const response = await buildHttpResponse({
    endPoint: `data/getSnapshots?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
  });
  return response as ChartRecord[];
}

// Function to fetch TAM data
export async function fetchTamData(
  start_date: string,
  end_date: string,
): Promise<ChartRecord[]> {
  const response = await buildHttpResponse({
    endPoint: `data/getTamData?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
  });
  return response as ChartRecord[];
}

export async function fetchAuctionData({
  startDate,
  endDate,
}: {
  startDate: String;
  endDate: String;
}) {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/search-auction/?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching auctions:", error);
    return [];
  }
}

export async function fetchDamAnalysisData({
  startDate,
  endDate,
  entity,
}: {
  startDate: String;
  endDate: String;
  entity: string;
}) {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/getDamAnalysisData?start_date=${startDate}&end_date=${endDate}&entity=${entity}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching dam analysis:", error);
    return [];
  }
}

export async function getDmrcLoadData({
  startDate,
  endDate,
  entity,
}: {
  startDate: String;
  endDate: String;
  entity?: string;
}): Promise<DmrcLoad[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `dmrc/getDmrcData?start_date=${startDate}&end_date=${endDate}&entity=${entity}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching dam analysis:", error);
    return [];
  }
}
export async function getDmrcForecastLoadData({
  startDate,
  endDate,
  entity,
}: {
  startDate: String;
  endDate: String;
  entity?: string;
}): Promise<DmrcForecastedLoad[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `dmrc/getDmrForecastcData?start_date=${startDate}&end_date=${endDate}&entity=${entity}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching dam analysis:", error);
    return [];
  }
}
export async function dmrcChatGptRes({
  query,
  thread_token,
}: {
  query: string;
  thread_token: string;
}): Promise<{ sender: String; content: String }> {
  const response = await buildHttpResponse({
    endPoint: `dmrc/handeUserQuery?query=${query}&thread_token=${thread_token}`,
    method: HttpMethod.GET,
  });
  return response;
}

// POST dmrc/create_thread
export async function createThread(): Promise<{ thread_token: string }> {
  const response = await buildHttpResponse({
    endPoint: `dmrc/create_thread`,
    method: HttpMethod.POST,
  });
  return response;
}

export async function getGasConsumptionData({
  startDate,
  endDate,
  sectorName,
}: {
  startDate?: string;
  endDate?: string;
  sectorName?: string;
}): Promise<import("../models/gas").ConsumptionData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);
    if (sectorName) queryParams.append("sector_name", sectorName);

    const response = await buildHttpResponse({
      endPoint: `gas/getConsumptionData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response.map((item: import("../models/gas").ConsumptionData) => {
      const month = item.month.slice(0, 3);
      const numberOfDays = GetNumberOfDaysInMonth(month, item.year);
      return {
        ...item,
        month: item.month.slice(0, 3) + "`" + item.year.toString().slice(2, 4),
        domestic_consumption_mmscmd: item.domestic_consumption / numberOfDays,
        rlng_consumption_mmscmd: item.rlng_consumption / numberOfDays,
        total_consumption_mmscmd: item.total_consumption / numberOfDays,
        fyear: getFiscalYear(month, item.year),
        quarter:
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_year: item.month + "-" + item.year,
        month_quarter:
          item.month +
          "-" +
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_fyear: item.month + "-" + getFiscalYear(month, item.year),
      };
    });
  } catch (error) {
    console.error("Error fetching consumption data:", error);
    return [];
  }
}

// API to fetch Production Data
export async function getGasProductionData({
  startDate,
  endDate,
  stateName,
}: {
  startDate?: string;
  endDate?: string;
  stateName?: string;
}): Promise<ProductionData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);
    if (stateName) queryParams.append("state_name", stateName);

    const response = await buildHttpResponse({
      endPoint: `gas/getProductionData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response.map((item: ProductionData) => {
      const month = item.month.slice(0, 3);
      const numberOfDays = GetNumberOfDaysInMonth(month, item.year);

      return {
        ...item,
        month: month + "`" + item.year.toString().slice(2, 4),
        state__state_name: item.state__state_name.replace("Off shore", ""),
        month_year: item.month + "-" + item.year,
        value_mmscmd: item.value / numberOfDays,
        quarter:
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_quarter:
          item.month +
          "-" +
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_fyear: item.month + "-" + getFiscalYear(month, item.year),

        fyear: getFiscalYear(month, item.year),
      };
    });
  } catch (error) {
    console.error("Error fetching production data:", error);
    return [];
  }
}

// API to fetch LNG Import Data
export async function getGasLNGImportData({
  startDate,
  endDate,
}: {
  startDate?: string;
  endDate?: string;
}): Promise<LNGImportData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);

    const response = await buildHttpResponse({
      endPoint: `gas/getLNGImportData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response.map((item: LNGImportData) => {
      const month = item.month.slice(0, 3);
      const numberOfDays = GetNumberOfDaysInMonth(month, item.year);

      return {
        ...item,
        month: item.month.slice(0, 3) + "`" + item.year.toString().slice(2, 4),
        mmscmd: item.mmscm / numberOfDays,
        rs_mmscm: item.rs_crore / item.mmscm,
        usd_mmscm: item.million_usd / item.mmscm,
        quarter:
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_year: item.month + "-" + item.year,
        month_quarter:
          item.month +
          "-" +
          getQuarter(month) +
          "`" +
          getFiscalYear(month, item.year).toString().slice(2, 4),
        month_fyear: item.month + "-" + getFiscalYear(month, item.year),

        fyear: getFiscalYear(month, item.year),

        inr_mbtu: (item.rs_crore * 10000000) / (item.mmscm * 35314.7),
        usd_mbtu: (item.million_usd * 1000000) / (item.mmscm * 35314.7),
      };
    });
  } catch (error) {
    console.error("Error fetching LNG import data:", error);
    return [];
  }
}

export async function getPowerStationsData({
  state,
  sector,
  month,
  year,
}: {
  state?: string; // state ID (optional)
  sector?: string; // sector ID (optional)
  month?: string; // month (optional)
  year?: string; // year (optional)
}): Promise<PowerStationData[]> {
  try {
    const queryParams = new URLSearchParams();
    if (state) queryParams.append("state", state);
    if (sector) queryParams.append("sector", sector);
    if (month) queryParams.append("month", month);
    if (year) queryParams.append("year", year);

    const response = await buildHttpResponse({
      endPoint: `gas/getPowerStationsData?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching power station data:", error);
    return [];
  }
}

export async function getPowerGenerationData({
  start_date,
  end_date,
}: {
  start_date: string;
  end_date: string;
}): Promise<PowerGeneration[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/getGenerationData?start_date=${start_date}&end_date=${end_date}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching power generation data:", error);
    return [];
  }
}

export async function getGridcoDiscomData(
  startDate: string,
  endDate: string,
): Promise<GridcoDiscomData[]> {
  try {
    const response: Promise<GridcoDiscomData[]> = await buildHttpResponse({
      endPoint: `gridco/getDiscomDataTemp?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    const res = await response;
    const uniqueDates = Array.from(new Set(res.map((item) => item.date)));
    return (await response).map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        drawal_mwh: item.drawal_mw / 4,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Discom Drawl data:", error);
    return [];
  }
}

export async function getGridcoCollectiveData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<RajasthanCollective[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `gridco/getCollective?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response.map((item: any) => {
      return {
        ...item,
        time_slot: item.slot,
        wt_mcp_rs_kwh: item.rate,
        cost: ((item.rate * item.value_mw) / 4) * 1000,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan Collective Data:", error);
    return [];
  }
}

export async function uploadGridcoNetScheduleFile(formData: any): Promise<{
  automation_files: Array<{ file_url: string }>;
}> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/automation",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function getProcurementRecord(
  page: any,
  perpage: any,
): Promise<RajProcurementRecord[]> {
  try {
    const response = await fetch(
      `https://datahub.gna.energy/rajasthan_procurement?page=${page}&per_page=${perpage}`,
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error("Error fetching Procurement Record :", error);
    return [];
  }
}

export async function uploadGridcoFile(formData: any): Promise<string> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/upload_gridco_file", // Replace with your endpoint
    method: HttpMethod.POST,
    formData,
  });
  return response.message;
}

export async function createFileType(name: string): Promise<string> {
  const response = await buildHttpResponse({
    endPoint: "gridco/create_file_type", // Replace with your endpoint
    method: HttpMethod.POST,
    body: { name },
  });
  return response.message;
}

export async function deleteFileType(name: string): Promise<string> {
  const response = await buildHttpResponse({
    endPoint: "gridco/delete_file_type", // Replace with your endpoint
    method: HttpMethod.POST,
    body: { name },
  });
  return response.message;
}
export async function getGridcoUploadedFile(): Promise<string[]> {
  const response = await buildHttpResponse({
    endPoint: "gridco/getGridcoUploadedFile",
    method: HttpMethod.GET,
  });
  return response;
}

export async function getGridcoFileTypes(): Promise<string[]> {
  const response = await buildHttpResponse({
    endPoint: "gridco/get_gridco_file_types",
    method: HttpMethod.GET,
  });
  return response;
}

export async function getGridcoIntraGen({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<IntrastateGen[]> {
  const response = await buildHttpResponse({
    endPoint: `gridco/get_intrastate_gen_adjusted_data?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  if (!Array.isArray(response)) return [];
  const uniqueDates = Array.from(
    new Set((response as IntrastateGen[]).map((item) => item.date)),
  );
  return response.map((item) => {
    return {
      ...item,
      generator_type: titleCase(item.generator_type),
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      time_block: item.time_block,
      slot: item.time_block,
    };
  });
}

export async function getGridcoIsgsGeneratorVise({
  startDate,
  endDate,
  generator,
}: {
  startDate: string;
  endDate: string;
  interval?: string;
  generator?: string[];
}): Promise<GridoIsgs[]> {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });
  if (generator && generator.length > 0) {
    params.append("generator", generator.join(","));
  }
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoIsgsGeneratorData?${params.toString()}`,
    method: HttpMethod.GET,
  });

  const uniqueDates = Array.from(
    new Set(response.map((item: { date: any }) => item.date)),
  );
  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: item.date ? getMonthFromDate(item.date) : item.month,
      slot: item.time_block,
      time_block: item.time_block,
    };
  });
}

export async function getGridcoIsgs({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<GridoIsgs[]> {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoIsgsData?${params.toString()}`,
    method: HttpMethod.GET,
  });
  if (!Array.isArray(response)) return [];
  const uniqueDates = Array.from(
    new Set(response.map((item: { date: any }) => item.date)),
  );
  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: item.date ? getMonthFromDate(item.date) : item.month,
      slot: item.time_block,
      time_block: item.time_block,
    };
  });
}

export async function getGridcoIsgsGeneratorDataPaginated({
  page,
  record,
  generator,
  startDate,
  endDate,
}: {
  page: number;
  record: number;
  generator?: string[];
  startDate: string;
  endDate: string;
}): Promise<PaginatedResponse<GridoIsgs>> {
  const params = new URLSearchParams({
    page: String(page),
    records: String(record),
    start_date: startDate,
    end_date: endDate,
  });
  if (generator && generator.length > 0) {
    params.append("generator", generator.join(","));
  }
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoIsgsGeneratorDataPaginated?${params.toString()}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getGridcoIsgsExportJobId({
  startDate,
  endDate,
  interval,
  filters,
}: {
  startDate: string;
  endDate: string;
  interval?: string;
  filters?: Record<string, any>;
}): Promise<IsgsExportJobResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/isgs/export`,
    method: HttpMethod.POST,
    noCache: true,
    body: {
      start_date: startDate,
      end_date: endDate,
      interval: interval,
      ...filters,
    },
  });

  return response;
}
export async function getGridcoIsgsStationList({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<
  Array<{ generator: string; gen_type: string; gen_ownership: string }>
> {
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoISGSGenerator?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });

  return response;
}

export async function getGridcoIsgsExportStatus({
  startDate,
  endDate,
  job_id,
}: {
  startDate: string;
  endDate: string;
  job_id: string;
}): Promise<IsgsExportJobResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/isgs/export-status?start_date=${startDate}&end_date=${endDate}&job_id=${job_id}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response;
}

export async function getGridcoRegen({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<GridoIsgs[]> {
  const response = await buildHttpResponse({
    endPoint: `gridco/get_re_gen_data?start_date=${startDate}&end_date=${endDate}`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  if (!Array.isArray(response)) return [];
  const uniqueDates = Array.from(
    new Set(response.map((item: { date: any }) => item.date)),
  );
  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
      time_block: item.slot,
      slot: item.slot,
      discom_name: item.discom__name,
      generator_type: item.generator_type__name,
      ownership: item.ownership__name,
      sub_station: item.sub_station__name,
    };
  });
}

export async function getCombinedGenerators({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<{
  intrastate: string[];
  isgs: string[];
  re: string[];
}> {
  const response = await buildHttpResponse({
    endPoint: `gridco/getCombinedGenerators?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getCombinedGenDataMultiple({
  startDate,
  endDate,
  intrastateGenerators,
  isgsGenerators,
  reGenerators,
}: {
  startDate: string;
  endDate: string;
  intrastateGenerators: string[];
  isgsGenerators: string[];
  reGenerators: string[];
}): Promise<GenerationCommon[]> {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });
  intrastateGenerators.forEach((g) => params.append("intrastate_generator", g));
  isgsGenerators.forEach((g) => params.append("isgs_generator", g));
  reGenerators.forEach((g) => params.append("re_generator", g));

  const response = await buildHttpResponse({
    endPoint: `gridco/getCombinedGenDataMultiple?${params.toString()}`,
    method: HttpMethod.GET,
  });
  if (!response || typeof response !== "object") return [];

  const allItems: GenerationCommon[] = [];

  const intrastateItems: any[] = Array.isArray(response.intrastate)
    ? response.intrastate
    : [];
  const isgsItems: any[] = Array.isArray(response.isgs) ? response.isgs : [];
  const reItems: any[] = Array.isArray(response.re) ? response.re : [];

  intrastateItems.forEach((item: any) => {
    allItems.push({
      ...item,
      value_mw: item.experi_value ?? 0,
      value_mwh: (item.experi_value ?? 0) / 4,
      area: "Intrastate",
      generator_type: titleCase(item.generator_type),
      time_block: item.time_block,
      slot: item.time_block,
      month: getMonthFromDate(item.date),
      dates: `${startDate} to ${endDate}`,
    });
  });

  isgsItems.forEach((item: any) => {
    allItems.push({
      ...item,
      value_mw: item.experi_value ?? 0,
      value_mwh: (item.experi_value ?? 0) / 4,
      area: "Interstate",
      station_name: item.beneficiery_from,
      generator_type: titleCase(item.generator_type),
      time_block: item.time_block,
      slot: item.time_block,
      month: getMonthFromDate(item.date),
      dates: `${startDate} to ${endDate}`,
    });
  });

  reItems.forEach((item: any) => {
    allItems.push({
      ...item,
      value_mw: item.value_mw ?? 0,
      value_mwh: (item.value_mw ?? 0) / 4,
      area: "Intrastate",
      station_name: item.sub_station__name,
      generator_type: titleCase(item.generator_type__name),
      ownership: item.ownership__name,
      sub_station: item.sub_station__name,
      discom_name: item.discom__name,
      time_block: item.slot,
      slot: item.slot,
      month: getMonthFromDate(item.date),
      dates: `${startDate} to ${endDate}`,
    });
  });

  return allItems;
}

export async function getCombinedGenDataPaginated({
  startDate,
  endDate,
  intrastateGenerators,
  isgsGenerators,
  reGenerators,
  page,
  records,
}: {
  startDate: string;
  endDate: string;
  intrastateGenerators: string[];
  isgsGenerators: string[];
  reGenerators: string[];
  page: number;
  records: number;
}): Promise<{
  data: GenerationCommon[];
  totalRecords: { intrastate: number; isgs: number; re: number };
  totalPages: number;
}> {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
    page: String(page),
    records: String(records),
  });
  intrastateGenerators.forEach((g) => params.append("intrastate_generator", g));
  isgsGenerators.forEach((g) => params.append("isgs_generator", g));
  reGenerators.forEach((g) => params.append("re_generator", g));

  const response = await buildHttpResponse({
    endPoint: `gridco/getCombinedGenDataPaginated?${params.toString()}`,
    method: HttpMethod.GET,
  });
  if (!response || typeof response !== "object") {
    return {
      data: [],
      totalRecords: { intrastate: 0, isgs: 0, re: 0 },
      totalPages: 0,
    };
  }

  const allItems: GenerationCommon[] = [];

  const intrastateItems: any[] = Array.isArray(response.intrastate?.data)
    ? response.intrastate.data
    : [];
  const isgsItems: any[] = Array.isArray(response.isgs?.data)
    ? response.isgs.data
    : [];
  const reItems: any[] = Array.isArray(response.re?.data)
    ? response.re.data
    : [];

  intrastateItems.forEach((item: any) => {
    allItems.push({
      ...item,
      value_mw: item.experi_value ?? 0,
      value_mwh: (item.experi_value ?? 0) / 4,
      area: "Intrastate",
      generator_type: titleCase(item.generator_type),
      time_block: item.time_block,
      slot: item.time_block,
      month: getMonthFromDate(item.date),
      dates: `${startDate} to ${endDate}`,
    });
  });

  isgsItems.forEach((item: any) => {
    allItems.push({
      ...item,
      value_mw: item.experi_value ?? 0,
      value_mwh: (item.experi_value ?? 0) / 4,
      area: "Interstate",
      station_name: item.beneficiery_from,
      generator_type: titleCase(item.generator_type),
      time_block: item.time_block,
      slot: item.time_block,
      month: getMonthFromDate(item.date),
      dates: `${startDate} to ${endDate}`,
    });
  });

  reItems.forEach((item: any) => {
    allItems.push({
      ...item,
      value_mw: item.value_mw ?? 0,
      value_mwh: (item.value_mw ?? 0) / 4,
      area: "Intrastate",
      station_name: item.sub_station__name,
      generator_type: titleCase(item.generator_type__name),
      ownership: item.ownership__name,
      sub_station: item.sub_station__name,
      discom_name: item.discom__name,
      time_block: item.slot,
      slot: item.slot,
      month: getMonthFromDate(item.date),
      dates: `${startDate} to ${endDate}`,
    });
  });

  const totalPages = Math.max(
    response.intrastate?.total_pages ?? 0,
    response.isgs?.total_pages ?? 0,
    response.re?.total_pages ?? 0,
  );

  return {
    data: allItems,
    totalRecords: {
      intrastate: response.intrastate?.total_records ?? 0,
      isgs: response.isgs?.total_records ?? 0,
      re: response.re?.total_records ?? 0,
    },
    totalPages,
  };
}

export async function getHaryanaDiscomData(
  startDate: string,
  endDate: string,
): Promise<HarayanaDiscomData[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemand?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res;

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));
    return data.map((item: any) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        demand_mw: parseFloat(item.demand_mw.toString()),
        demand_mwh: parseFloat(item.demand_mw.toString()) / 4,
        demand_lu: parseFloat(item.demand_mw.toString()) / 400,
        month: getMonthFromDate(item.date),
        year: getYearFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaLoadMetrics({
  ranges,
  aggregated,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  const response = await buildHttpResponse({
    endPoint: `haryana/getHaryanaLoadMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}

// New API function for demand metrics
export async function getHaryanaDemandMetrics(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemandMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        time_string: item.time_string,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          (item.mode_demand || item.mode_demand_window_formula || 0).toString(),
        ),
        mode_demand: parseFloat((item.mode_demand || 0).toString()),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Demand Metrics data:", error);
    return [];
  }
}

// New API function for trend metrics
export async function getHaryanaTrendMetrics({
  ranges,
  aggregated,
  discom,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `haryana/getHaryanaTrendMetrics${query}&discom=${discom}`,
    method: HttpMethod.GET,
  });

  return response;
}

export async function getHaryanaSurplusDeficitMetrics({
  ranges,
  aggregated,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `haryana/getHaryanaSurplusDeficitMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}

export async function getHaryanaIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<HaryanaIsgs[]> {
  try {
    const response: Promise<{ data: HaryanaIsgs[] }> = await buildHttpResponse({
      endPoint: `haryana/getIsgs?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item) => {
      return {
        ...item,
        value_mw: parseFloat(item.value_mw.toString()),
        value_mwh: parseFloat(item.value_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getHaryanaGnaTgnaData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<HaryanaGnaTgna[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getOaGnaTgna?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res;
    console.log(data);
    return data.map((item: any) => {
      return {
        ...item,
        value_mw: parseFloat(item.value_mw.toString()),
        value_mwh: parseFloat(item.value_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana ISGS Data:", error);
    return [];
  }
}

export async function getHaryanaRemcData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<HaryanaRemc[]> {
  try {
    const response: Promise<{ data: HaryanaRemc[] }> = await buildHttpResponse({
      endPoint: `haryana/getOaRemc?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item) => {
      return {
        ...item,
        value_mw: parseFloat(item.value_mw.toString()),
        value_mwh: parseFloat(item.value_mw.toString()) / 4,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getHaryanaYearlyProcurementData(): Promise<
  HaryanaYearlyProcurementData[]
> {
  const response = await buildHttpResponse({
    endPoint: `haryana/getYearlyProcurement`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response.data;
}

export async function getHaryanaMonthlyProcurementData(): Promise<
  HaryanaMonthlyProcurementData[]
> {
  const response = await buildHttpResponse({
    endPoint: `haryana/getMonthlyProcurement`, // Replace with your endpoint
    method: HttpMethod.GET,
  });
  return response.data.map((item: HaryanaMonthlyProcurementData) => {
    return {
      ...item,
      month: getMonthYear({ month: item.month - 1, year: parseInt(item.year) }),
    };
  });
}

export async function getHaryanaForecast(
  startDate: string,
  endDate: string,
): Promise<HarayanaDiscomData[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getForcast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res;

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));

    // Process data and create separate entries for D+1 and D+2
    const processedData: any[] = [];

    data.forEach((item: any) => {
      const dateIndex =
        (uniqueDates.indexOf(item.date) + 1).toString() + " Day";
      const dates = `${startDate} to ${endDate}`;

      const baseData = {
        dateIndex: dateIndex,
        dates: dates,
        block: item.slot,
        date: item.date,
        time_string: item.time_string,
        month: getMonthFromDate(item.date),

        // Actual demand (base line) - this comes from demand API, but we include it here for reference
        demand_mw: parseFloat(item.demand_mw?.toString() || "0"),
        demand_mwh: parseFloat(item.demand_mw?.toString() || "0") / 4,
        demand_lu: parseFloat(item.demand_mw?.toString() || "0") / 400,

        // Actual Generation fields
        actual_generation_mw: parseFloat(
          item.actual_generation?.toString() || "0",
        ),
        actual_generation_mwh:
          parseFloat(item.actual_generation?.toString() || "0") / 4,
        actual_generation_lu:
          parseFloat(item.actual_generation?.toString() || "0") / 400,

        // Surplus/Deficit fields
        surplus_deficit_mw: parseFloat(
          item.surplus_deficit_mw?.toString() || "0",
        ),
        surplus_deficit_mwh:
          parseFloat(item.surplus_deficit_mw?.toString() || "0") / 4,
        surplus_deficit_lu:
          parseFloat(item.surplus_deficit_mw?.toString() || "0") / 400,
        surplus_deficit_percentage: parseFloat(
          item.surplus_deficit_percentage?.toString() || "0",
        ),
      };

      // Add D+1 forecast if available
      if (
        item.demand_d_plus_one !== null &&
        item.demand_d_plus_one !== undefined
      ) {
        processedData.push({
          ...baseData,
          forcast_type: "D+1",
          // Store as demand_d_plus_one for aggregation
          demand_d_plus_one_mw: parseFloat(
            item.demand_d_plus_one?.toString() || "0",
          ),
          demand_d_plus_one_mwh:
            parseFloat(item.demand_d_plus_one?.toString() || "0") / 4,
          demand_d_plus_one_lu:
            parseFloat(item.demand_d_plus_one?.toString() || "0") / 400,
        });
      }

      // Add D+2 forecast if available
      if (
        item.demand_d_plus_two !== null &&
        item.demand_d_plus_two !== undefined
      ) {
        processedData.push({
          ...baseData,
          forcast_type: "D+2",
          // Store as demand_d_plus_two for aggregation
          demand_d_plus_two_mw: parseFloat(
            item.demand_d_plus_two?.toString() || "0",
          ),
          demand_d_plus_two_mwh:
            parseFloat(item.demand_d_plus_two?.toString() || "0") / 4,
          demand_d_plus_two_lu:
            parseFloat(item.demand_d_plus_two?.toString() || "0") / 400,
        });
      }
    });

    return processedData;
  } catch (error) {
    console.error("Error fetching Haryana Forecast data:", error);
    return [];
  }
}

export async function getHaryanaForecastMetrics(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemandForecastMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          (item.mode_demand || item.mode_demand_window_formula || 0).toString(),
        ),
        mode_demand: parseFloat((item.mode_demand || 0).toString()),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Forecast Metrics data:", error);
    return [];
  }
}

export async function getHaryanaForecastMetricsTwoDays(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getDemandForecastMetricsTwoDays?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;

    return res.map((item: any) => {
      return {
        slot: item.slot,
        forecast_type: item.forecast_type,
        time_string: item.time_string,
        min_demand: parseFloat((item.min_demand || 0).toString()),
        max_demand: parseFloat((item.max_demand || 0).toString()),
        avg_demand: parseFloat((item.avg_demand || 0).toString()),
        mode_demand_window_formula: parseFloat(
          (item.mode_demand || item.mode_demand_window_formula || 0).toString(),
        ),
        mode_demand: parseFloat((item.mode_demand || 0).toString()),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error(
      "Error fetching Haryana Forecast Metrics Two Days data:",
      error,
    );
    return [];
  }
}

export async function getHaryanaDailyForecast(
  startDate: string,
  endDate: string,
): Promise<HarayanaDailyForecastData[]> {
  try {
    const response: Promise<{ data: HarayanaDailyForecastData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDailyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        demand_mw: parseFloat(item.daily_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_demand_value_mw.toString()),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaMonthlyForecast(
  startDate: string,
  endDate: string,
): Promise<HarayanaMonthlyForecastData[]> {
  try {
    const response: Promise<{ data: HarayanaMonthlyForecastData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getMonthlyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    let data = res.data;

    data.sort((a, b) => {
      if (a.year === b.year) {
        return Number(a.month) - Number(b.month);
      }
      return a.year - b.year;
    });

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return data.map((item) => ({
      ...item,
      month: `${monthNames[(item.month as any) - 1]} ${String(item.year).slice(
        2,
        4,
      )}`,
      year: parseFloat(item.year.toString()),
      demand_mw: parseFloat(item.peak_mw.toString()),
      average_mw: parseFloat(item.average_mw.toString()),
    }));
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getDailyDemandForecast(
  startDate: string,
  endDate: string,
): Promise<HarayanaMonthlyForecastData[]> {
  try {
    const response: Promise<{ data: HarayanaMonthlyForecastData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDailyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });
    const res = await response;
    let data = res.data;

    data.sort((a, b) => {
      if (a.year === b.year) {
        return Number(a.month) - Number(b.month);
      }
      return a.year - b.year;
    });

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return data.map((item) => ({
      ...item,
      month: `${monthNames[(item.month as any) - 1]} ${String(item.year).slice(
        2,
        4,
      )}`,
      year: parseFloat(item.year.toString()),
      demand_mw: parseFloat(item.peak_mw.toString()),
      average_mw: parseFloat(item.average_mw.toString()),
    }));
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaMonthlyPeak(
  startDate: string,
  endDate: string,
): Promise<HarayanaMonthlyPeakData[]> {
  try {
    const response: Promise<{ data: HarayanaMonthlyPeakData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getMonthlyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    let data = res.data;

    data.sort((a, b) => {
      if (a.year === b.year) {
        return Number(a.month) - Number(b.month);
      }
      return a.year - b.year;
    });

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return data.map((item) => ({
      ...item,
      month: `${monthNames[(item.month as any) - 1]} ${String(item.year).slice(
        2,
        4,
      )}`,
      year: parseFloat(item.year.toString()),
      demand_mw: parseFloat(item.peak_mw.toString()),
      average_mw: parseFloat(item.average_mw.toString()),
    }));
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaWeather(
  startDate: string,
  endDate: string,
): Promise<HarayanaWeatherData[]> {
  try {
    const response: Promise<{ data: HarayanaWeatherData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getWeatherData?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        month: getMonthFromDate(item.date),
        temperature_c: parseFloat(item.temperature_c.toString()),
        humidity_percent: parseFloat(item.humidity_percent.toString()),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

export async function getHaryanaDailyPeak(
  startDate: string,
  endDate: string,
): Promise<HarayanaDailyPeakData[]> {
  try {
    const response: Promise<{ data: HarayanaDailyPeakData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDailyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        peak_mw: parseFloat(item.daily_peak_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_daily_peak_demand_value_mw.toString()),
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString(),
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString(),
        ),
        morning_peak_slot: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

// Monthly Peak API
export async function getHaryanaMonthlyPeakDiscom(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getMonthlyPeakDemand?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        average_mw: parseFloat(item.average_mw.toString()),
        peak_mw: parseFloat(item.peak_mw.toString()),
        date_of_peak: item.date_of_peak,
        timeblock_of_peak: item.timeblock_of_peak,
        morning_peak_mw: parseFloat(item.morning_peak_mw.toString()),
        date_of_morning_peak: item.date_of_morning_peak,
        timeblock_of_morning_peak: item.timeblock_of_morning_peak,
        evening_peak_mw: parseFloat(item.evening_peak_mw.toString()),
        date_of_evening_peak: item.date_of_evening_peak,
        timeblock_of_evening_peak: item.timeblock_of_evening_peak,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Monthly Peak data:", error);
    return [];
  }
}

// Forecast Daily Peak API
export async function getHaryanaForecastDailyPeak(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getDailyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        peak_mw: parseFloat(item.daily_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_demand_value_mw.toString()),
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString(),
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString(),
        ),
        morning_peak_slot: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Forecast Daily Peak data:", error);
    return [];
  }
}

export async function getHaryanaForecastDailyPeakDemand(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getDailyPeakForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));
    return data.map((item: any) => {
      const eveningData =
        (item.formatted_data ?? []).find(
          (f: any) => f.time_period === "Evening",
        ) ?? {};
      const morningData =
        (item.formatted_data ?? []).find(
          (f: any) => f.time_period === "Morning",
        ) ?? {};
      return {
        date: item.date,
        forecast_type: item.forecast_type ?? "T+1", // "T+1" or "T+2"
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        month: getMonthFromDate(item.date),
        peak_mw: parseFloat(
          (item.daily_peak_forecasted_demand_mw ?? 0).toString(),
        ),
        average_mw: parseFloat(
          (item.avg_daily_forecasted_demand_mw ?? 0).toString(),
        ),
        evening_peak_mw: parseFloat(
          (eveningData.max_forecasted_demand ?? 0).toString(),
        ),
        evening_peak_slot: eveningData.max_forecasted_demand_block ?? null,
        morning_peak_mw: parseFloat(
          (morningData.max_forecasted_demand ?? 0).toString(),
        ),
        morning_peak_slot: morningData.max_forecasted_demand_block ?? null,
      };
    });
  } catch (error) {
    console.error(
      "Error fetching Haryana Forecast Daily Peak (getDailyPeakForecast):",
      error,
    );
    return [];
  }
}

// Forecast Monthly Peak API
export async function getHaryanaForecastMonthlyPeak(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<{ data: any[] }> = await buildHttpResponse({
      endPoint: `haryana/getMonthlyDemandForecast?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data;

    return data.map((item: any) => {
      return {
        month: item.month,
        year: item.year,
        average_mw: parseFloat(item.average_mw.toString()),
        peak_mw: parseFloat(item.peak_mw.toString()),
        date_of_peak: item.date_of_peak,
        timeblock_of_peak: item.timeblock_of_peak,
        morning_peak_mw: parseFloat(item.morning_peak_mw.toString()),
        date_of_morning_peak: item.date_of_morning_peak,
        timeblock_of_morning_peak: item.timeblock_of_morning_peak,
        evening_peak_mw: parseFloat(item.evening_peak_mw.toString()),
        date_of_evening_peak: item.date_of_evening_peak,
        timeblock_of_evening_peak: item.timeblock_of_evening_peak,
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Forecast Monthly Peak data:", error);
    return [];
  }
}

export async function getXgHaryanaForecast(
  startDate: string,
  endDate: string,
): Promise<HarayanaDiscomData[]> {
  try {
    const response: Promise<{ data: HarayanaDiscomData[] }> =
      await buildHttpResponse({
        endPoint: `haryana/getDemandForecast?start_date=${startDate}&end_date=${endDate}`,
        method: HttpMethod.GET,
      });

    const res = await response;
    const data = res.data;

    const uniqueDates = Array.from(new Set(data.map((item) => item.date)));
    return data.map((item) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        block: item.slot,
        demand_mw: parseFloat(item.demand_value_mw.toString()),
        demand_mwh: parseFloat(item.demand_value_mw.toString()) / 4,
        value_mw: parseFloat(item.demand_value_mw.toString()),
        value_mwh: parseFloat(item.demand_value_mw.toString()) / 4,
        type__name: "Demand",

        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Haryana Discom data:", error);
    return [];
  }
}

// getGenerationForecastData
export async function getHaryanaGenerationForecastData(
  startDate: string,
  endDate: string,
): Promise<HaryanaData[]> {
  const response = await buildHttpResponse({
    endPoint: `haryana/getGenerationForecast?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response.data.map((item: HaryanaData) => {
    return {
      ...item,
      sub_type: item.type__name,

      type__name: "Generation",
    };
  });
}

export async function getExchangeCollectiveData(
  startDate: string,
  endDate: string,
) {
  const response = await buildHttpResponse({
    endPoint: `data/getCollectiveData?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response.data.map((item: any): { type: string } & typeof item => {
    return {
      ...item,
      type: "Actual",
      month: getMonthFromDate(item.date),
      slot: item.time_slot,
      wt_mcp_rs_kwh: item.wt_mcp_rs_mwh / 1000,
    };
  });
}

export async function getExchangeCollectiveForecastData(
  startDate: string,
  endDate: string,
  product: string,
  exchange: string,
) {
  const response = await buildHttpResponse({
    endPoint: `data/getCollectiveForecast?start_date=${startDate}&end_date=${endDate}&exchange=${exchange}&product=${product}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response.map((item: any): { type: string } & typeof item => {
    return {
      ...item,
      type: "Forecast",
      month: getMonthFromDate(item.date),
      slot: item.time_block,
      wt_mcp_rs_kwh: item.mcp,
      wt_mcp_rs_mwh: item.mcp,
    };
  });
}

export async function getPriceForecastIEXDaily(
  startDate: string,
  endDate: string,
  interval = "date",
) {
  const response = await buildHttpResponse({
    endPoint: `data/getDataPriceForecast?start_date=${startDate}&end_date=${endDate}&interval=${interval}&exchange=IEX&product=DAM`,
    method: HttpMethod.GET,
    noCache: true,
  });

  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date)),
  );

  return response.map((item: any) => {
    return {
      ...item,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
    };
  });
}

export async function getCollectiveMetrics({
  ranges,
  aggregated,
}: GetCollectiveMetricsParams): Promise<ExchangeMetrics | ExchangeMetrics[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `data/getExchangeMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}

export async function calculateBankingCost(
  params: BankingCalculateParams
): Promise<BankingCalculateResponse> {
  const response = await buildHttpResponse({
    endPoint: `data/api/banking/calculate/`,
    method: HttpMethod.POST,
    body: params,
  });
  return response;
}

export async function exportBankingExcel(
  data: BankingCalculateResponse & { supply_from?: string; supply_to?: string; return_pct?: number }
): Promise<Blob> {
  const url = buildBaseUrl("data/api/banking/export/");
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error("Export failed");
  return res.blob();
}

export async function getTraderBlockData({
  startDate,
  endDate,
  trader,
  product,
  state_of_buyer,
  state_of_seller,
  name_of_seller,
  name_of_buyer,
  category_of_buyer,
  category_of_seller,
  transaction_type,
}: {
  startDate: string;
  endDate: string;
  product: string;
  trader: string;
  state_of_buyer: string;
  state_of_seller: string;
  name_of_seller: string;
  name_of_buyer: string;
  category_of_buyer: string;
  category_of_seller: string;
  transaction_type: string;
}): Promise<TradersData[]> {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/getTradingBlockData`,
      method: HttpMethod.POST,
      body: {
        start_date: startDate,
        end_date: endDate,
        trader,
        product,
        state_of_buyer,
        state_of_seller,
        name_of_seller,
        name_of_buyer,
        category_of_buyer,
        category_of_seller,
        transaction_type,
      },
    });

    return response.results.map((item: any) => {
      return {
        ...item,
        month: getMonthFromDate(item.date),
      };
    });
  } catch (error) {
    console.error("Error fetching Trader Data:", error);
    return [];
  }
}

export async function getGridcoIsgsData({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): Promise<gridcoIsgs[]> {
  try {
    const response = (await buildHttpResponse({
      endPoint: `gridco/getGridcoIsgsData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    })) as gridcoIsgs[];

    const uniqueDates = Array.from(new Set(response.map((item) => item.date)));
    return response.map((item) => {
      return {
        ...item,
        generator_type: titleCase(item.generator_type),
        time_block: item.slot,
        value_mwh: item.experi_value / 4,
        value_mw: item.experi_value,
        station: item.beneficiery_from,
        expp_value_mw: item.expp_value,
        experi_value_mw: item.experi_value,
        losses_value_mw: item.losses || 0,
        losses_value_mwh: (item.losses || 0) / 4,
        entitlement_value_mw: item.entitlement_value,
        expp_value_mwh: item.expp_value / 4,
        experi_value_mwh: item.experi_value / 4,
        entitlement_value_mwh: item.entitlement_value / 4,
        month: getMonthFromDate(item.date),
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
      };
    });
  } catch (error) {
    console.error("Error fetching Rajasthan ISGS Data:", error);
    return [];
  }
}

export async function getGridcoMeter(
  startDate: string,
  endDate: string,
  selectedDiscom?: Array<string>,
) {
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoMeter?start_date=${startDate}&end_date=${endDate}&discom=${selectedDiscom}`,
    method: HttpMethod.GET,
  });

  // Get unique dates from the response
  const uniqueDates = Array.from(
    new Set(response.map((item: any) => item.date)),
  );

  return response.map((item: any) => {
    return {
      ...item,
      value_mw: item.value_mw || 0,
      value_mwh: item.value_mw / 4,
      dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
      dates: `${startDate} to ${endDate}`,
      month: getMonthFromDate(item.date),
    };
  });
}

// Optional Query Parameters:
// page
// Type: Query Parameter
// Format: ?page=2
// Default: 1
// Description: The page number you want to retrieve
// Example: http://your-domain/gpt/sessions/?page=2

export const sendThumbsFeedback = async (
  invocationId: string,
  thumbsUp: boolean,
): Promise<ThumbsFeedbackResult> => {
  try {
    // const response = await fetch(`${API_BASE}/gpt/events/thumbs-up/`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     invocation_id: invocationId,
    //     thumbs_up: thumbsUp,
    //   }),
    // });
    const response = await buildHttpResponse({
      endPoint: `https://api-data.gna.energy/gpt/events/thumbs-up/`,
      method: HttpMethod.POST,
      customHeader: {
        Authorization: "fbce857c-f28d-4141-b714-8f4be7f743fe",
      },

      body: {
        invocation_id: invocationId,
        thumbs_up: thumbsUp,
      },
    });

    return response as ThumbsFeedbackResponse;
  } catch (error) {
    return {
      error:
        error instanceof Error ? error.message : "An unexpected error occurred",
    };
  }
};

export async function getAgentEvents(): Promise<AgentEvent[]> {
  const response = await buildHttpResponse({
    endPoint: `https://api-data.gna.energy/gpt/events`,
    customHeader: {
      Authorization: "fbce857c-f28d-4141-b714-8f4be7f743fe",
    },

    method: HttpMethod.GET,
  });
  return response;
}

export async function getLatestForecastDate({
  product,
  exchange,
}: {
  product: string;
  exchange: string;
}) {
  const response = await buildHttpResponse({
    endPoint: `data/getLatestPriceForecastData?product=${product}&exchange=${exchange}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getMonthlyPriceForecast(
  priceType: "simple_avg" | "wt_avg" = "wt_avg",
) {
  const response = await buildHttpResponse({
    endPoint: `data/getThreeMonthMonthlyForecastSummary?exchange=IEX&product=DAM&price_type=${priceType}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getLatestDataPriceForecastDate() {
  const response = await buildHttpResponse({
    endPoint: `data/getLatestDataPriceForecastDate`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD START POST Session
// MOD Gridco START POST Session
export async function fetchgetModSession(startdate: string) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/startSession?date=${startdate}`,
    method: HttpMethod.POST,
    body: {
      date: startdate,
    },
  });
  return response;
}

export async function getModSession() {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSession`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD Stage data
export async function ModStagePost(stage: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postStage`,
    method: HttpMethod.POST,
    body: {
      stage: stage,
      session: session,
    },
  });
  return response;
}
export async function fetchModGridcoArchive(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getPreviousSession?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModGridcoActivateSession(session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/activateSession`,
    method: HttpMethod.POST,
    body: {
      session: session,
    },
    noCache: true,
  });
  return response;
}
// MOD DAM default data
export async function fetchModDamDefault(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDefaultData/dam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}
// MOD GDAM default data
export async function fetchModGDamDefault(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDefaultData/gdam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchModGDamData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getData/gdam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD RTM default data
export async function fetchModRtmDefault(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDefaultData/rtm?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}
export async function fetchModDemandDefault(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDemandDefault?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
  });
  return response;
}

// upload file POST DAM RTM DEMAND
export async function ModDamData(ModDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postDam`,
    method: HttpMethod.POST,
    body: ModDamdata,
  });

  return response as ApiResponse;
}

export async function ModGDamData(ModGDamdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postGDam`,
    method: HttpMethod.POST,
    noCache: true,
    body: ModGDamdata,
  });

  return response as ApiResponse;
}

export async function ModRtmData(ModRtmdata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postRtm`,
    method: HttpMethod.POST,
    body: ModRtmdata,
  });

  return response as ApiResponse;
}
export async function ModDemandData(ModDemanddata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postDemand`,
    method: HttpMethod.POST,
    body: ModDemanddata,
  });

  return response as ApiResponse;
}
// MOD Aggregated Load Price Data
export async function ModAggregatedLoadData(
  ModAggregatedData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postAggregatedLoadPrice`,
    method: HttpMethod.POST,
    body: ModAggregatedData,
  });

  return response as ApiResponse;
}

// MOD DAM fetch Data
export async function fetchModDamData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getData/dam?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModDemandData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getDemand?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// MOD RTM fetch Data
export async function fetchModRtmData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getData/rtm?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// MOD TABLE fetch Data
export async function fetchModTableData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getMOD?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModTableChartData(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getMODChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchModTableChartDataClassified(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getMODChartClassified?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// BID final TABLE fetch Data
export async function fetchModBidTableData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function ModGridcoUpdateBidData(
  ModUpdatedata: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function getModGridcoBidSimulationData(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorBid?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
// post uploadGridcoModFile

export async function ModBulkUploadFile(formData: any): Promise<{
  automationMod_files: Array<{ file_url: string }>;
}> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/automation",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function ModUpdateData(ModUpdatedata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postMOD`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function postMODChartClassified(
  payload: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/postMODChartClassified`,
    method: HttpMethod.POST,
    body: payload,
  });

  return response as ApiResponse;
}

export async function CreateBidTable(ModUpdatedata: any): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/createBid`,
    method: HttpMethod.POST,
    body: ModUpdatedata,
  });

  return response as ApiResponse;
}

export async function getPriceIndexData(startDate: string, endDate: string) {
  const response = await buildHttpResponse({
    endPoint: `data/get_price_index_datewise?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export interface PriceIndexAdvancedParams {
  start_date: string;
  end_date: string;
  function_type?: "cumulative" | "comparative";
  sources?: string[];
}

export interface PriceIndexAdvancedData {
  date: string;
  mwh: number;
  rsKWh: number;
  source_type?: string; // Only present in comparative mode
}

export async function getPriceIndexAdvanced(
  params: PriceIndexAdvancedParams,
): Promise<PriceIndexAdvancedData[]> {
  try {
    const queryParams = new URLSearchParams({
      start_date: params.start_date,
      end_date: params.end_date,
    });

    if (params.function_type) {
      queryParams.append("function_type", params.function_type);
    }

    if (params.sources && params.sources.length > 0) {
      queryParams.append("sources", params.sources.join(","));
    }

    const response = await buildHttpResponse({
      endPoint: `data/get_price_index_datewise_advanced?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });

    // Handle response structure - check if it's wrapped in a data property
    if (response && typeof response === "object" && "data" in response) {
      return (response as any).data as PriceIndexAdvancedData[];
    }

    return response as PriceIndexAdvancedData[];
  } catch (error) {
    console.error("Error fetching price index advanced data:", error);
    throw error;
  }
}

//Simulator Summary
export async function fetchModSimulationSummary(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorGenChart?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

//Simulator Station
export async function fetchModSimulationStation(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getData4?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

//Simulator Cost of Power
export async function fetchModSimulationCostPower(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorCostPower?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
//Simulator Sale Revenue (IEX DAM)
export async function fetchModSimulationSaleRevenue(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorSalesRevenue?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchModSimulationTopBuyer(
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/getSimulatorGenPrice?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export const formatDateToDDMMYYYY = (date: Date | string): string => {
  const dateObj = new Date(date);
  const day = dateObj.getDate().toString().padStart(2, "0");
  const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
};

export async function getCollectiveData(
  startDate: string,
  endDate: string,
): Promise<ExchangeBidData[]> {
  const response = await buildHttpResponse({
    endPoint: `data/getData/?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response.data.map((item: any) => ({
    ...item,
    wt_mcp_rs_mwh: parseFloat(item.wt_mcp_rs_mwh),
    purchase_bid_mwh: parseFloat(item.purchase_bid_mw) / 4,
    sell_bid_mwh: parseFloat(item.sell_bid_mw) / 4,
    mcv_mwh: parseFloat(item.mcv_mw) / 4,
  }));
}
export async function getPriceAnalysisData(
  params: PriceAnalysisParams,
): Promise<PriceAnalysisData[]> {
  try {
    const queryParams = new URLSearchParams({
      interval: params.interval,
      price_type: params.price_type,
      exchange_name: params.exchange_name,
      product_name: params.product_name,
    });

    if (params.start_date) {
      queryParams.append("start_date", params.start_date);
    }
    if (params.end_date) {
      queryParams.append("end_date", params.end_date);
    }

    const response = await buildHttpResponse({
      endPoint: `data/price-analysis/?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });

    return response as PriceAnalysisData[];
  } catch (error) {
    console.error("Error fetching price analysis data:", error);
    throw error;
  }
}

export async function getTopBuyerSellerData(
  params: BuyerSellerParams,
): Promise<BuyerSellerResponse> {
  try {
    const formData = new FormData();
    formData.append("exchange", params.exchange);
    formData.append("product", params.product);
    formData.append("region", params.region);
    formData.append("start_date", params.start_date);
    formData.append("end_date", params.end_date);

    const response = await buildHttpResponse({
      endPoint: "data/getTopBuyerSeller/",
      method: HttpMethod.POST,
      body: formData,
    });

    return response as BuyerSellerResponse;
  } catch (error) {
    console.error("Error fetching top buyer seller data:", error);
    throw error;
  }
}

export async function getConsumptionData(
  startDate: string,
  endDate: string,
): Promise<ConsumptionData[]> {
  const response = await buildHttpResponse({
    endPoint:
      "data/consumption_api?start_date=" + startDate + "&end_date=" + endDate,
    method: HttpMethod.GET,
  });
  const data = response.map((item: any) => ({
    ...item,
    date: item.date,
    energy_met_mu: parseFloat(item.energy_met_mu),
    state: item.state,
  }));
  console.log("Consumption Data = ", data);
  return data;
}

export async function getOutageData(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  const response = await buildHttpResponse({
    endPoint:
      "data/generation_outage_api?start_date=" +
      startDate +
      "&end_date=" +
      endDate,
    method: HttpMethod.GET,
  });

  return response;
}

export async function getGenerationData(
  startDate: string,
  endDate: string,
): Promise<GenerationData[]> {
  const response = await buildHttpResponse({
    endPoint:
      "data/generation_data_api?start_date=" +
      startDate +
      "&end_date=" +
      endDate,
    method: HttpMethod.GET,
  });

  return response
    .map((item: any) => ({
      ...item,
      date: item.date,
      generation_mu_actual: parseFloat(item.generation_mu_actual),
    }))
    .sort(
      (a: any, b: any) =>
        new Date(a.date).getTime() - new Date(b.date).getTime(),
    );
}

export async function getByExchangeData(startDate: string, endDate: string) {
  const response = await buildHttpResponse({
    endPoint: `data/getData/?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getBuyerSellersTrendData(
  formData: FormData,
): Promise<any> {
  const response = await buildHttpResponse({
    endPoint: `data/getBuyerSellerTrendData/`,
    method: HttpMethod.POST,
    body: formData,
  });
  return response;
}

export async function getBuyerSellersData(formData: FormData): Promise<any> {
  const response = await buildHttpResponse({
    endPoint: `data/getTopBuyerSeller/`,
    method: HttpMethod.POST,
    body: formData,
  });
  return response;
}

export async function getRealTimePrices() {
  const response = await buildHttpResponse({
    endPoint: `data/getRealtimeIexPrices/`,
    method: HttpMethod.GET,
  });

  const transformedData: {
    date: string;
    block: number;
    rate_type: string;
    rate_value: number;
  }[] = [];

  const dates = Object.keys(response);

  for (const date of dates) {
    const dayData = response[date];
    const timeSlots = Object.keys(dayData.DAM_rates);

    timeSlots.forEach((timeSlot, index) => {
      const block = index + 1;

      // Create separate object for DAM
      transformedData.push({
        date: date,
        block: block,
        rate_type: "DAM",
        rate_value: dayData.DAM_rates[timeSlot],
      });

      // Create separate object for GDAM
      transformedData.push({
        date: date,
        block: block,
        rate_type: "GDAM",
        rate_value: dayData.GDAM_rates[timeSlot],
      });

      // Create separate object for RTM
      transformedData.push({
        date: date,
        block: block,
        rate_type: "RTM",
        rate_value: dayData.RTM_rates[timeSlot],
      });
    });
  }

  return transformedData;
}

export async function getCoalStockData(
  startDate: string,
  endDate: string,
): Promise<{
  success: boolean;
  data: Array<{
    date: string;
    actual_stock_in_tt_total: number;
    price_rs_per_ton_indian_coal: number | null;
    actual_stock_in_tt_total_prev_year: number;
    price_rs_per_ton_indian_coal_prev_year: number;
  }>;
  count: number;
}> {
  try {
    const response = await buildHttpResponse({
      endPoint: `data/coal-stock-datewise/?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });
    return response;
  } catch (error) {
    console.error("Error fetching coal stock data:", error);
    return {
      success: false,
      data: [],
      count: 0,
    };
  }
}

//Exchange Analysis Overview Tab in Haryana API

// export async function getExchangeAnalysisData(
//   params: ExchangeAnalysisParams
// ): Promise<ExchangeAnalysisData[]> {
//   try {
//     const queryParams = new URLSearchParams({
//       interval: params.interval,
//       price_type: params.price_type,
//       exchange_name: params.exchange_name,
//       product_name: params.product_name,
//     });

//     if (params.start_date) {
//       queryParams.append("start_date", params.start_date);
//     }
//     if (params.end_date) {
//       queryParams.append("end_date", params.end_date);
//     }
//     if (params.function) {
//       queryParams.append("function", params.function);
//     }
//     const response = await buildHttpResponse({
//       endPoint: `data/exchange-analysis/?${queryParams.toString()}`,
//       method: HttpMethod.GET,
//     });

//     return response as ExchangeAnalysisData[];
//   } catch (error) {
//     console.error("Error fetching exchange analysis data:", error);
//     throw error;
//   }
// }
export async function fetchLgbrTableData(startdate: string, session: number) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/get-lgbr?date=${startdate}&session=${session}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchLgbrGetData(
  type: string | null,
  time_slot: number | null,
  startdate: string,
  session: number,
) {
  const response = await buildHttpResponse({
    endPoint: `mod_gridco/get-lgbr-generator?date=${startdate}&session=${session}&type=${type}&time_slot=${time_slot}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

//Exchange Analysis Overview Tab in Haryana API

export async function getExchangeAnalysisData(
  params: ExchangeAnalysisParams,
): Promise<ExchangeAnalysisData[]> {
  try {
    const queryParams = new URLSearchParams({
      interval: params.interval,
      price_type: params.price_type,
      exchange_name: params.exchange_name,
      product_name: params.product_name,
    });

    if (params.start_date) {
      queryParams.append("start_date", params.start_date);
    }
    if (params.end_date) {
      queryParams.append("end_date", params.end_date);
    }
    if (params.function) {
      queryParams.append("function", params.function);
    }
    if (params.blocks && params.blocks.length > 0) {
      const blocksParam = params.blocks.join(",");
      queryParams.append("blocks", blocksParam);
    }
    const response = await buildHttpResponse({
      endPoint: `data/exchange-analysis/?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });

    return response as ExchangeAnalysisData[];
  } catch (error) {
    console.error("Error fetching exchange analysis data:", error);
    throw error;
  }
}

export interface PowerExchangeAnalysisParams {
  interval: "slot" | "day" | "week" | "month";
  function?: "comparative" | "cumulative";
  exchange_name?: string;
  product_name?: string;
  entity_name?: string;
  start_date?: string;
  end_date?: string;
}

export interface PowerExchangeAnalysisData {
  x_axis: string;
  second_x_axis: string | null;
  type__name: string;
  exchange__name: string | null;
  entity__name: string | null;
  product__name: string | null;
  amount_mw: number | null;
  amount_mwh: number;
  cost: number;
  wt_avg_price: number; // Weighted average price in Rs/kWh
}

export interface PowerExchangeAnalysisSummary {
  total_drawal_cost: number;
  total_drawal_volume_mu: number;
  total_injection_cost: number;
  total_injection_volume_mu: number;
}

export interface PowerExchangeAnalysisResponse {
  data: PowerExchangeAnalysisData[];
  summary: PowerExchangeAnalysisSummary;
}

export async function getPowerExchangeAnalysisData(
  params: PowerExchangeAnalysisParams,
): Promise<PowerExchangeAnalysisResponse> {
  try {
    const queryParams = new URLSearchParams({
      interval: params.interval,
    });

    if (params.function) {
      queryParams.append("function", params.function);
    }
    if (params.exchange_name) {
      queryParams.append("exchange_name", params.exchange_name);
    }
    if (params.product_name) {
      queryParams.append("product_name", params.product_name);
    }
    if (params.entity_name) {
      queryParams.append("entity_name", params.entity_name);
    }
    if (params.start_date) {
      queryParams.append("start_date", params.start_date);
    }
    if (params.end_date) {
      queryParams.append("end_date", params.end_date);
    }

    const response = await buildHttpResponse({
      endPoint: `power_exchange_analytics/power-exchange-analysis?${queryParams.toString()}`,
      method: HttpMethod.GET,
    });

    return response as PowerExchangeAnalysisResponse;
  } catch (error) {
    console.error("Error fetching power exchange analysis data:", error);
    throw error;
  }
}

export interface AvailableEntity {
  id: number;
  name: string;
  key_name: string;
}

export interface GetAvailableEntitiesParams {
  start_date?: string;
  end_date?: string;
}

export async function getAvailableEntities(
  params?: GetAvailableEntitiesParams,
): Promise<AvailableEntity[]> {
  try {
    const queryParams = new URLSearchParams();

    if (params?.start_date) {
      queryParams.append("start_date", params.start_date);
    }
    if (params?.end_date) {
      queryParams.append("end_date", params.end_date);
    }

    const queryString = queryParams.toString();
    const endPoint = queryString
      ? `power_exchange_analytics/available-entities?${queryString}`
      : `power_exchange_analytics/available-entities`;

    const response = await buildHttpResponse({
      endPoint: endPoint,
      method: HttpMethod.GET,
    });

    return response as AvailableEntity[];
  } catch (error) {
    console.error("Error fetching available entities:", error);
    throw error;
  }
}

//Entity Analysis Api in Exchange tab in HPPC

export async function getEntityComparisonV2({
  entityid,
  exchangeName,
  productName,
  startDate,
  endDate,
  function: functionType = "cumulative",
}: {
  entityid: number;
  exchangeName: string;
  productName: string;
  startDate: string;
  endDate: string;
  function?: "cumulative" | "comparative";
}): Promise<any[]> {
  const response = await fetch(
    `https://api-data.gna.energy/data/getSlotWiseAggregatedEntityDataV2/?exchange_name=${exchangeName}&product_name=${productName}&start_date=${startDate}&end_date=${endDate}&function=${functionType}&entitity_id=${entityid}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  const data = await response.json();
  return data.data as any[];
}

export async function getHaryanaGenerationProfile(
  startDate: string,
  endDate: string,
  sourcesParam: string = "",
): Promise<any[]> {
  try {
    const response: Promise<any[]> = await buildHttpResponse({
      endPoint: `haryana/getGenerationProfile?start_date=${startDate}&end_date=${endDate}${sourcesParam}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    return res;
  } catch (error) {
    console.error("Error fetching Haryana Generation Profile data:", error);
    return [];
  }
}

//Gridco Demand Page API's

// Gridco Daily Peak API
export async function getGridcoDailyPeak(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getDailyPeakData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));
    return data.map((item: any) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        // Use daily_demand_value_mw as peak
        peak_mw: parseFloat(item.daily_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_demand_value_mw.toString()),
        // Evening is at index 0
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString(),
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        // Morning is at index 1
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString(),
        ),
        morning_peak_slot: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Daily Peak data:", error);
    return [];
  }
}

// Gridco Monthly Peak API
export async function getGridcoMonthlyPeak(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getMonthlyPeakData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    return data.map((item: any) => {
      const [monthStr, yearStr] = item.month_year.split("-");
      const month = parseInt(monthStr);
      const year = parseInt(yearStr);

      return {
        month: month,
        year: year,
        month_year: item.month_year,
        average_mw: parseFloat(item.average_monthly_demand_mw.toString()),
        peak_mw: parseFloat(item.peak_monthly_demand_mw.toString()),
        // Evening peak data (index 0)
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString(),
        ),
        date_of_evening_peak:
          item.formatted_data[0].max_demand_date?.split("T")[0],
        timeblock_of_evening_peak: item.formatted_data[0].max_demand_slot,
        // Morning peak data (index 1)
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString(),
        ),
        date_of_morning_peak:
          item.formatted_data[1].max_demand_date?.split("T")[0],
        timeblock_of_morning_peak: item.formatted_data[1].max_demand_slot,
        // Overall peak info
        date_of_peak: item.formatted_data[1].max_demand_date?.split("T")[0],
        timeblock_of_peak: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Monthly Peak data:", error);
    return [];
  }
}

// Gridco Demand Metrics API for Summary
export async function getGridcoDemandMetrics(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getDemandMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    return data.map((item: any) => {
      return {
        slot: item.slot,
        time_string: item.time_string,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          item.mode_demand_window_formula.toString(),
        ),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Demand Metrics data:", error);
    return [];
  }
}

export async function getGridcoScheduleData(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getGridcoSchedule?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));

    return data.map((item: any) => {
      const date = new Date(item.date);
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const month = monthNames[date.getMonth()];

      return {
        date: item.date,
        block: item.slot, // Map slot to block
        discom: item.discom__name, // Map discom__name to discom
        schedule_mw: parseFloat(item.schedule_mw.toString()),
        schedule_mwh: parseFloat(item.schedule_mw.toString()) / 4,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: month,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Schedule data:", error);
    return [];
  }
}

// Gridco Schedule Daily Peak API
export async function getGridcoScheduleDailyPeak(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getScheduleDailyPeakData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    const uniqueDates = Array.from(new Set(data.map((item: any) => item.date)));
    return data.map((item: any) => {
      return {
        ...item,
        dateIndex: (uniqueDates.indexOf(item.date) + 1).toString() + " Day",
        dates: `${startDate} to ${endDate}`,
        month: getMonthFromDate(item.date),
        // Use daily_demand_value_mw as peak
        peak_mw: parseFloat(item.daily_demand_value_mw.toString()),
        average_mw: parseFloat(item.avg_demand_value_mw.toString()),
        // Evening is at index 0
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString(),
        ),
        evening_peak_slot: item.formatted_data[0].max_demand_slot,
        // Morning is at index 1
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString(),
        ),
        morning_peak_slot: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Schedule Daily Peak data:", error);
    return [];
  }
}

// Gridco Schedule Monthly Peak API
export async function getGridcoScheduleMonthlyPeak(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getScheduleMonthlyPeakData?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    return data.map((item: any) => {
      const [monthStr, yearStr] = item.month_year.split("-");
      const month = parseInt(monthStr);
      const year = parseInt(yearStr);

      return {
        month: month,
        year: year,
        month_year: item.month_year,
        average_mw: parseFloat(item.average_monthly_demand_mw.toString()),
        peak_mw: parseFloat(item.peak_monthly_demand_mw.toString()),
        // Evening peak data (index 0)
        evening_peak_mw: parseFloat(
          item.formatted_data[0].max_demand.toString(),
        ),
        date_of_evening_peak:
          item.formatted_data[0].max_demand_date?.split("T")[0],
        timeblock_of_evening_peak: item.formatted_data[0].max_demand_slot,
        // Morning peak data (index 1)
        morning_peak_mw: parseFloat(
          item.formatted_data[1].max_demand.toString(),
        ),
        date_of_morning_peak:
          item.formatted_data[1].max_demand_date?.split("T")[0],
        timeblock_of_morning_peak: item.formatted_data[1].max_demand_slot,
        // Overall peak info
        date_of_peak: item.formatted_data[1].max_demand_date?.split("T")[0],
        timeblock_of_peak: item.formatted_data[1].max_demand_slot,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Schedule Monthly Peak data:", error);
    return [];
  }
}

export async function getGridcoScheduleDemandMetrics(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  try {
    const response: Promise<any> = await buildHttpResponse({
      endPoint: `gridco/getScheduleDemandMetrics?start_date=${startDate}&end_date=${endDate}`,
      method: HttpMethod.GET,
    });

    const res = await response;
    const data = res.data || res;

    if (!Array.isArray(data)) {
      console.error("Unexpected data format:", data);
      return [];
    }

    return data.map((item: any) => {
      return {
        slot: item.slot,
        time_string: item.time_string,
        min_demand: parseFloat(item.min_demand.toString()),
        max_demand: parseFloat(item.max_demand.toString()),
        avg_demand: parseFloat(item.avg_demand.toString()),
        mode_demand_window_formula: parseFloat(
          item.mode_demand_window_formula.toString(),
        ),
        date_of_min: item.date_of_min,
        date_of_max: item.date_of_max,
      };
    });
  } catch (error) {
    console.error("Error fetching Gridco Schedule Demand Metrics data:", error);
    return [];
  }
}
//Surplus Deficit API's

export async function fetchSurplusOptimizerSession(
  startDate: string,
  endDate: string,
) {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessSession?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.POST,
    body: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response;
}

export async function getBessTaskStatus(taskId: string) {
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessTaskStatus?task_id=${taskId}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getSurplusOptimizerSession() {
  const response = await buildHttpResponse({
    endPoint: `haryana/getSurDefSession`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Updated REST API functions for the new endpoints

export async function AddBatteryData(
  TraderOffersData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessAddBess`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}
export async function AddCapacityData(
  TraderOffersData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessAddCap`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}
export async function getSurplusharayanaSession() {
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessSession`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getSurplusOptimizerBatteryData(scenario_id?: number) {
  const response = await buildHttpResponse({
    endPoint:
      scenario_id !== undefined
        ? `haryana/getBessAddBess?scenario_id=${scenario_id}`
        : `haryana/getBessAddBess`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getSurplusOptimizerCapacityData(scenario_id?: number) {
  const response = await buildHttpResponse({
    endPoint:
      scenario_id !== undefined
        ? `haryana/getBessAddCap?scenario_id=${scenario_id}`
        : `haryana/getBessAddCap`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getSurplusOptimizerSummaryChart() {
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessProfile`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getBessResultSummary(scenarioIds?: number[]) {
  const queryParams = new URLSearchParams();
  if (scenarioIds && scenarioIds.length > 0) {
    queryParams.append("scenario_id", scenarioIds.join(","));
  }

  const response = await buildHttpResponse({
    endPoint: `haryana/getBessResultSummary?${queryParams.toString()}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Apply button API
export async function postBessPageInfo(data: any) {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessPageInfo`,
    method: HttpMethod.POST,
    body: data,
    noCache: true,
  });
  return response;
}

// Make Scenario button API
export async function postBessMakeScenario(data: any) {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessMakeScenario`,
    method: HttpMethod.POST,
    body: data,
    noCache: true,
  });
  return response;
}

// Switch Scenario API
export async function postBessSwitchScenario(scenario: number) {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessSwitchScenario`,
    method: HttpMethod.POST,
    body: { scenario: scenario },
    noCache: true,
  });
  return response;
}

// In your API file (e.g., haryanaApi.ts or similar)

export async function getBessGeneratorCharges() {
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessGeneratorCharges`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function postBessGeneratorChargesChange(data: any[]) {
  const response = await buildHttpResponse({
    endPoint: `haryana/postBessGeneratorChargesChange`,
    method: HttpMethod.POST,
    body: data,
    noCache: true,
  });
  return response;
}

export async function getBessSummaryTab(
  start_date: string,
  end_date: string,
  scenario: number,
) {
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessSummaryTab?start_date=${start_date}&end_date=${end_date}&scenario=${scenario}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Power Market API's

export async function getPowerExchangeCollectiveData(
  start_date: string,
  end_date: string,
  exchanges?: string[],
  products?: string[],
) {
  // Build query string with optional exchanges and products
  let queryParams = `start_date=${start_date}&end_date=${end_date}`;

  if (exchanges && exchanges.length > 0) {
    queryParams += `&exchanges=${exchanges.join(",")}`;
  }

  if (products && products.length > 0) {
    queryParams += `&products=${products.join(",")}`;
  }

  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/collective-data?${queryParams}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Power Exchange Demand Generation API
export async function getPowerExchangeDemandGeneration(
  start_date: string,
  end_date: string,
) {
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/demand-generation?start_date=${start_date}&end_date=${end_date}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export interface TopBuyerSellerItem {
  name: string;
  value: number;
  [key: string]: any;
}

export interface TopBuyerSellerResponse {
  top_buyers: TopBuyerSellerItem[];
  top_sellers: TopBuyerSellerItem[];
}

export async function getTopBuyersSellers(
  startDate: string,
  endDate: string,
  exchange?: string[],
  product?: string[],
): Promise<TopBuyerSellerResponse> {
  let query = `start_date=${startDate}&end_date=${endDate}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/top-buyers-sellers?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as TopBuyerSellerResponse;
}

export interface TopBuyerSellerDeltaItem {
  name: string;
  value_range_1: number;
  value_range_2: number;
  delta: number;
  percent_change: number;
  [key: string]: any;
}

export interface TopBuyerSellerDeltaResponse {
  largest_drawal_changes: TopBuyerSellerDeltaItem[];
  largest_injection_changes: TopBuyerSellerDeltaItem[];
}

export async function getTopBuyerSellerDelta(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  exchange?: string[],
  product?: string[],
): Promise<TopBuyerSellerDeltaResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/top-buyer-seller-delta?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as TopBuyerSellerDeltaResponse;
}

export async function getTopBuyerSellerSlotwise(
  startDate: string,
  endDate: string,
  exchange?: string[],
  product?: string[],
  timeBlocks?: string[],
): Promise<TopBuyerSellerResponse> {
  let query = `start_date=${startDate}&end_date=${endDate}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  if (timeBlocks && timeBlocks.length > 0) {
    query += `&time_blocks=${timeBlocks.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/top-buyer-seller-slotwise?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as TopBuyerSellerResponse;
}

export async function getTopBuyerSellerSlotwiseDelta(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  exchange?: string[],
  product?: string[],
  timeBlocks?: string[],
): Promise<TopBuyerSellerDeltaResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  if (timeBlocks && timeBlocks.length > 0) {
    query += `&time_blocks=${timeBlocks.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/top-buyer-seller-slotwise-delta?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as TopBuyerSellerDeltaResponse;
}

export interface SummaryDataValues {
  avg_mcp: number;
  avg_buy_bid: number;
  avg_sell_bid: number;
  mcv: number;
  all_india_demand: number;
  all_india_generation: number;
  peak_demand: number;
}

export interface SummaryDataResponse {
  current_values: SummaryDataValues;
  changed_values: SummaryDataValues;
  current_date: {
    start: string;
    end: string;
  };
  comparison_date: {
    start: string;
    end: string;
  };
  market_summary?: string;
}

export async function getSummaryData(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  exchange?: string[],
  product?: string[],
): Promise<SummaryDataResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/get-summary-data?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as SummaryDataResponse;
}

export interface EntityDeltaItem {
  utility: string;
  drawal_delta_mwh?: number;
  injection_delta_mwh?: number;
  temp_delta: number;
  precipitation_delta: number;
  solar_intensity_delta: number;
  outage_delta_mw: number;
  total_outage_mw: number;
  load_delta_mw: number;
}

export interface EntityDeltaResponse {
  top_drawal_changes: EntityDeltaItem[];
  top_injection_changes: EntityDeltaItem[];
}

export async function getEntityDelta(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  exchange?: string[],
  product?: string[],
): Promise<EntityDeltaResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/get-entity-delta?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as EntityDeltaResponse;
}

// ----------------------------------------------------------------------
// Interval Summary (Time Block)
// ----------------------------------------------------------------------

export interface IntervalSummaryResponse {
  interval: string;
  timeblocks: number[];
  current_values: SummaryDataValues;
  changed_values: SummaryDataValues;
  top_drawal_changes: EntityDeltaItem[];
  top_injection_changes: EntityDeltaItem[];
  current_date: {
    start: string;
    end: string;
  };
  comparison_date: {
    start: string;
    end: string;
  };
  market_summary?: string;
}

export async function getIntervalSummary(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  exchange?: string[],
  product?: string[],
): Promise<IntervalSummaryResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/get-interval-summary?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as IntervalSummaryResponse;
}

export interface StateOutageSectorData {
  [date: string]: {
    [sector: string]: {
      outage: number;
      monitored_cap: number;
    };
  };
}

export interface StateOutageSectorResponse {
  state: string;
  range_1: StateOutageSectorData;
  range_2: StateOutageSectorData;
}

export async function getStateOutageSectorwise(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  state: string,
  exchange?: string[],
  product?: string[],
): Promise<StateOutageSectorResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}&state=${state}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/state-outage-sectorwise?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as StateOutageSectorResponse;
}

export async function getStateOutagePowerType(
  startDate1: string,
  endDate1: string,
  startDate2: string,
  endDate2: string,
  state: string,
  exchange?: string[],
  product?: string[],
): Promise<StateOutageSectorResponse> {
  let query = `start_date_1=${startDate1}&end_date_1=${endDate1}&start_date_2=${startDate2}&end_date_2=${endDate2}&state=${state}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/state-outage-powertype?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as StateOutageSectorResponse;
}

export interface StateBlockMetrics {
  drawal_mw: number;
  injection_mw: number;
  actual_drawal_mw: number;
  forecast_drawal_mw: number;
  temperature: number;
  rain: number;
  cloud_cover: number;
  direct_radiation: number;
  humidity: number;
}

export interface StateMetricsResponse {
  state: string;
  range: { [block: string]: StateBlockMetrics };
}

export async function getStateMetrics(
  startDate: string,
  endDate: string,
  state: string,
  exchange?: string[],
  product?: string[],
): Promise<StateMetricsResponse> {
  let query = `start_date=${startDate}&end_date=${endDate}&state=${state}`;
  if (exchange && exchange.length > 0) {
    query += `&exchange=${exchange.join(",")}`;
  }
  if (product && product.length > 0) {
    query += `&product=${product.join(",")}`;
  }
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/state-metrics?${query}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as unknown as StateMetricsResponse;
}

// GNA TGNA API's

export async function fetchOptimizerSession(
  startDate: string,
  endDate: string,
) {
  const response = await buildHttpResponse({
    endPoint: `gridco/start-gna-session?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.POST,
    body: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response;
}
export async function getGNAOptimizerSession() {
  const response = await buildHttpResponse({
    endPoint: `gridco/get-gna-session`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchOptimizerCurrentOptimisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-parameters`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchOptimizerSguGeneration() {
  const response = await buildHttpResponse({
    endPoint: `gridco/generation-profile`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function OptimizerCurrentUpdateData(
  Updatedata: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-parameters`,
    method: HttpMethod.POST,
    body: Updatedata,
  });

  return response as ApiResponse;
}

export async function OptimizerGnaProceed() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-proceed`,
    method: HttpMethod.POST,
  });

  return response as ApiResponse;
}
export async function fetchSimulatedUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-simulated-utilisation-slotwise`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchMonthlysimulatedUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-simulated-utilisation-monthly`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchDailysimulatedUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-simulated-utilisation-daily`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimalUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-optimal-utilisation-slotwise`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchMonthlyOptimalUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-optimal-utilisation-monthly`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchDailyOptimalUtilisation() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-optimal-utilisation-daily`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function fetchOptimizerStatistics() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-utilisation-statistics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimizerMetrics() {
  const response = await buildHttpResponse({
    endPoint: `gridco/gna-utilisation-metrics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimizerSummary() {
  const response = await buildHttpResponse({
    endPoint: `gridco/generation-profile-slotwise`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function OptimizerSguUpdateData(
  Updatedata: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/generation-profile`,
    method: HttpMethod.POST,
    body: Updatedata,
    noCache: true,
  });

  return response as ApiResponse;
}

export async function fetchOptimizerGeneration() {
  const response = await buildHttpResponse({
    endPoint: `gridco/generation-profile-cummulative`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Scenario Comparison - Total Generation API
export async function getBessTotalGeneration(scenarioIds: number[]) {
  const idsParam = scenarioIds.join(",");
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessTotalGeneration?scenario_ids=${idsParam}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Scenario Comparison - Capacity Summary API
export async function getBessCapacitySummary(scenarioIds: number[]) {
  const idsParam = scenarioIds.join(",");
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessCapacitySummary?scenario_ids=${idsParam}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Scenario Comparison - Cost Summary API (Daily Volume)
export async function getBessGenCostSummary(scenarioIds: number[]) {
  const idsParam = scenarioIds.join(",");
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessGenCostSummary?scenario_ids=${idsParam}&scenario_id=${idsParam}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Scenario Comparison - BESS Cost Summary API (Month/Year Volume)
export async function getBessBessCostSummary(scenarioIds: number[]) {
  const idsParam = scenarioIds.join(",");
  const response = await buildHttpResponse({
    endPoint: `haryana/getBessBessCostSummary?scenario_ids=${idsParam}&scenario_id=${idsParam}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function getBessLoadGenPeakHours({
  session_id,
  scenario_id,
  start_date,
  end_date,
}: {
  session_id?: string;
  scenario_id?: string;
  start_date?: string;
  end_date?: string;
}) {
  try {
    const queryParams = new URLSearchParams();
    if (session_id) queryParams.append("session_id", session_id);
    if (scenario_id) queryParams.append("scenario", scenario_id);
    if (start_date) queryParams.append("start_date", start_date);
    if (end_date) queryParams.append("end_date", end_date);

    const response = await buildHttpResponse({
      endPoint: `haryana/getBessLoadGenPeakHours?${queryParams.toString()}`,
      method: HttpMethod.GET,
      noCache: true,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Load Gen Peak Hours:", error);
    return null;
  }
}

// getBessLoadGenSummaryTab
export async function getBessLoadGenSummaryTab(params: any) {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await buildHttpResponse({
      endPoint: `haryana/getBessLoadGenSummaryTab?${queryParams}`,
      method: HttpMethod.GET,
      noCache: true,
    });
    return response;
  } catch (error) {
    console.error("Error fetching getBessLoadGenSummaryTab:", error);
    return null;
  }
}

export async function getBessSurDefPeakHours({
  session_id,
  scenario_id,
  start_date,
  end_date,
}: {
  session_id?: string;
  scenario_id?: string;
  start_date?: string;
  end_date?: string;
}) {
  try {
    const queryParams = new URLSearchParams();
    if (session_id) queryParams.append("session_id", session_id);
    if (scenario_id) queryParams.append("scenario", scenario_id);
    if (start_date) queryParams.append("start_date", start_date);
    if (end_date) queryParams.append("end_date", end_date);

    const response = await buildHttpResponse({
      endPoint: `haryana/getBessSurDefPeakHours?${queryParams.toString()}`,
      method: HttpMethod.GET,
      noCache: true,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Surplus Deficit Peak Hours:", error);
    return null;
  }
}

export async function getBessAnnualSummaryCharts({
  session_id,
  scenario_id,
  start_date,
  end_date,
}: {
  session_id?: string;
  scenario_id?: string;
  start_date?: string;
  end_date?: string;
}) {
  try {
    const queryParams = new URLSearchParams();
    if (session_id) queryParams.append("session_id", session_id);
    if (scenario_id) queryParams.append("scenario", scenario_id);
    if (start_date) queryParams.append("start_date", start_date);
    if (end_date) queryParams.append("end_date", end_date);

    const response = await buildHttpResponse({
      endPoint: `haryana/getBessAnnualSummaryCharts?${queryParams.toString()}`,
      method: HttpMethod.GET,
      noCache: true,
    });
    return response;
  } catch (error) {
    console.error("Error fetching Annual Summary Charts:", error);
    return null;
  }
}

export async function getBessSurplusDeficitSummaryTab(params: any) {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await buildHttpResponse({
      endPoint: `haryana/getBessSurplusDeficitSummaryTab?${queryParams}`,
      method: HttpMethod.GET,
      noCache: true,
    });
    return response;
  } catch (error) {
    console.error("Error fetching getBessSurplusDeficitSummaryTab:", error);
    return null;
  }
}

// Procurement Optimizer Session

export async function fetchProcurementGridcoSession(
  startDate: string,
  endDate: string,
) {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/start-session?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.POST,
    body: {
      start_date: startDate,
      end_date: endDate,
    },
  });
  return response;
}

export async function getProcurementGridcoSession() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/get-session`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function AddSurplusDeficitData(
  SurplusDeficitData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/upload-deficit-data`,
    method: HttpMethod.POST,
    noCache: true,
    body: SurplusDeficitData,
  });

  return response as ApiResponse;
}
export async function AddTraderOffersData(
  TraderOffersData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/add-trader-offers`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}
export async function UpdateTraderOffersData(
  TraderOffersData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/update-trader-offers`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}
export async function UpdateTraderOffersToggleData(
  TraderOffersData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/toggle-trader-offers`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}

export async function fetchTraderOffersData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/get-trader-offers`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimalTraderOffersData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/get-optimal-trader-offers`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function getStatusTraderOffersData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/get-status-power`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function StartSimulationProcurementData(
  TraderOffersData: any,
): Promise<ApiResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/start-simulation`,
    method: HttpMethod.POST,
    noCache: true,
    body: TraderOffersData,
  });

  return response as ApiResponse;
}

export async function fetchSimulationProcurementData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/simulation-data`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimalProcurementData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/optimal-data`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchProcurementcummulativeData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/simulation-data-cummulative`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchOptimalProcurementcummulativeData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/optimal-data-cummulative`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchProcurementSimulationMetricsData() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/all-metrics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchProcurementMetrics() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/simulation-data`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}
export async function fetchProcurementStatistics() {
  const response = await buildHttpResponse({
    endPoint: `gridco/procurement/summary-metrics`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export interface PeriodSummaryResponse {
  weighted_avg_mcp: number;
  all_india_demand: number;
  all_india_generation: number;
  peak_demand: number;
}

export async function getPeriodSummary({
  startDate,
  endDate,
  exchange,
  product,
}: {
  startDate: string;
  endDate: string;
  exchange: string;
  product: string;
}): Promise<PeriodSummaryResponse> {
  const queryParams = new URLSearchParams();
  queryParams.append("start_date", startDate);
  queryParams.append("end_date", endDate);
  queryParams.append("exchange", exchange);
  queryParams.append("product", product);

  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/get-period-summary?${queryParams.toString()}`,
    method: HttpMethod.GET,
  });
  return response as PeriodSummaryResponse;
}

export interface StateCostVolumeSummaryResponse {
  total_drawal_cost: number;
  total_drawal_volume_mu: number;
  total_injection_cost: number;
  total_injection_volume_mu: number;
}

export async function getStateCostVolumeSummary({
  startDate,
  endDate,
  state,
  product,
  exchange,
}: {
  startDate: string;
  endDate: string;
  state: string;
  product: string;
  exchange: string;
}): Promise<StateCostVolumeSummaryResponse> {
  const response = await buildHttpResponse({
    endPoint: `power_exchange_analytics/get-state-cost-volume-summary?start_date=${startDate}&end_date=${endDate}&state=${state}&product=${product}&exchange=${exchange}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getBessAllUserSession() {
  const response = await buildHttpResponse({
    endPoint: "haryana/getBessAllUserSession",
    method: HttpMethod.GET,
  });
  return response;
}

export async function postBessChangeActiveSession(payload: any) {
  const response = await buildHttpResponse({
    endPoint: "haryana/postBessChangeActiveSession",
    method: HttpMethod.POST,
    body: payload,
  });
  return response;
}

export async function getForecastMetrics(
  startDate: string,
  endDate: string,
  exchangeName: string = "IEX",
  productName: string = "DAM",
) {
  const response = await buildHttpResponse({
    endPoint: `data/getForecastMetrics?start_date=${startDate}&end_date=${endDate}&exchange_name=${exchangeName}&product_name=${productName}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

// Dam Performance Api's

export async function uploadGridcoDcFile(formData: any): Promise<any> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/mod-report/automation-dc",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function uploadGridcoScheduleFile(formData: any): Promise<any> {
  const response = await buildMultipartHttpResponse({
    endPoint: "gridco/mod-report/automation-scheduled",
    method: HttpMethod.POST,
    formData,
  });
  return response;
}

export async function getGridcoModReportExcel(date: string): Promise<Blob> {
  const token = getAccessToken() || "";
  const url = buildBaseUrl(`gridco/mod-report/excel-download?date=${date}`);
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(`Failed to download report: ${response.statusText}`);
  }
  return response.blob();
}
export async function getConsumptionGenerationSummaryData(
  startDate: string,
  endDate: string,
  states: string[],
  powerTypes?: string[],
) {
  const queryParams = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });

  if (states && states.length > 0) {
    queryParams.append("state", states.join(","));
  }

  if (powerTypes && powerTypes.length > 0) {
    queryParams.append("power_type", powerTypes.join(","));
  }

  const response = await buildHttpResponse({
    endPoint: `data/consumption_generation_summary_api?${queryParams.toString()}`,
    method: HttpMethod.GET,
  });

  return response;
}

// ─── Gridco Download Data ─────────────────────────────────────────────────────

export interface GeneratorFilterItem {
  name: string;
  generatorType: string;
  ownership: string;
}

export interface GridcoDownloadFiltersResponse {
  generators: GeneratorFilterItem[];
  discoms: string[];
  scheduleDiscoms: string[];
  substations: string[];
}

export async function fetchGridcoDownloadFilters(
  startDate: string,
  endDate: string,
): Promise<GridcoDownloadFiltersResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/download/filters?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response;
}

export interface GridcoStartDownloadPayload {
  dateRange: { startDate: string; endDate: string };
  dataType: "Demand" | "Generation";
  timeGranularity: string;
  fileFormat: string;
  groupBy?: string;
  groupBySelector?: string[];
  demandVariableType?: string[];
  generatorType?: string[];
  generatorOwnership?: string[];
  selectedGenerators?: string[];
  generationVariableType?: string[];
}

export interface GridcoStartDownloadResponse {
  job_id: string;
}

export async function startGridcoDownload(
  payload: GridcoStartDownloadPayload,
): Promise<GridcoStartDownloadResponse> {
  const response = await buildHttpResponse({
    endPoint: "gridco/download/start",
    method: HttpMethod.POST,
    noCache: true,
    body: payload,
  });
  return response;
}

export type GridcoJobStatus = "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED";

export interface GridcoJobStatusResponse {
  job_id: string;
  status: GridcoJobStatus;
  created_at?: string;
  link?: string;
  message?: string;
}

export async function pollGridcoDownloadStatus(
  jobId: string,
): Promise<GridcoJobStatusResponse> {
  const response = await buildHttpResponse({
    endPoint: `gridco/download/status?job_id=${jobId}`,
    method: HttpMethod.GET,
    noCache: true,
  });
  return response;
}

export async function cancelGridcoDownload(jobId: string): Promise<void> {
  await buildHttpResponse({
    endPoint: "gridco/download/cancel",
    method: HttpMethod.POST,
    noCache: true,
    body: { job_id: jobId },
  });
}

export async function getDiscomLoadMetrics({
  ranges,
  aggregated,
  discom,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Add discom filter if provided
  if (discom && discom.length > 0) {
    query += `&discom=${encodeURIComponent(JSON.stringify(discom))}`;
  }

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoLoadMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}
export async function getOverviewGenMetrics({
  ranges,
  aggregated,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoGenOverviewMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}
export async function getIsgsGenMetrics({
  ranges,
  aggregated,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoGenISGSMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}
export async function getIntrastateGenMetrics({
  ranges,
  aggregated,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoGenIntraStateMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}
// ─── Market Monitoring Metrics ────────────────────────────────────────────────

export interface MarketMonitoringExchangeData {
  weighted_avg_price: number | null;
  volume_mu: number | null;
}

export interface MarketMonitoringMetrics {
  product: string;
  start_month: string | null;
  end_month: string | null;
  exchanges: Record<string, MarketMonitoringExchangeData>;
  overall: MarketMonitoringExchangeData;
}

export async function fetchMarketMonitoringMetrics({
  exchange,
  market,
  product,
  start_month,
  end_month,
}: {
  exchange: string;
  market: string;
  product: string;
  start_month?: string;
  end_month?: string;
}): Promise<MarketMonitoringMetrics> {
  const queryParams = new URLSearchParams({ exchange, market, product });
  if (start_month) queryParams.append("start_month", start_month);
  if (end_month) queryParams.append("end_month", end_month);

  const response = await buildHttpResponse({
    endPoint: `data/market_monitoring_price_metrics_api?${queryParams.toString()}`,
    method: HttpMethod.GET,
    noCache: true,
  });

  return response as MarketMonitoringMetrics;
}
export async function getSubStationMetrics({
  ranges,
  aggregated,
  discom,
  station_name,
  meter_number,
}: any): Promise<any[]> {
  // Build query string from parameters.
  let query = `?aggregated=${aggregated}`;

  // Add ranges as JSON array
  const rangesJson = JSON.stringify(ranges);
  query += `&ranges=${encodeURIComponent(rangesJson)}`;

  // Add discom filter if provided
  if (discom && discom.length > 0) {
    query += `&discom=${encodeURIComponent(JSON.stringify(discom))}`;
  }

  // Add station_name filter if provided
  if (station_name && station_name.length > 0) {
    query += `&station=${encodeURIComponent(JSON.stringify(station_name))}`;
  }

  // Add meter_number filter if provided
  if (meter_number && meter_number.length > 0) {
    query += `&meter_number=${encodeURIComponent(JSON.stringify(meter_number))}`;
  }

  // Adjust the endpoint URL as needed.
  const response = await buildHttpResponse({
    endPoint: `gridco/getGridcoSubStationMetrics${query}`,
    method: HttpMethod.GET,
  });

  return response;
}

// ─── Consumption & Generation Slotwise ────────────────────────────────────────

export async function getConsumptionGenerationSlotwiseData(
  startDate: string,
  endDate: string,
): Promise<any[]> {
  const response = await buildHttpResponse({
    endPoint: `data/consumption_generation_slotwise_api?start_date=${startDate}&end_date=${endDate}`,
    method: HttpMethod.GET,
  });
  return response as any[];
}

export async function getCAGSlotwiseMetrics(
  ranges: { startDate: string; endDate: string }[],
  states: string[],
  blocks?: string[] | number[],
): Promise<any> {
  const queryParams = new URLSearchParams();
  queryParams.append("ranges", JSON.stringify(ranges));
  if (states && states.length > 0) {
    queryParams.append("state", states.join(","));
  }
  if (blocks && blocks.length > 0) {
    queryParams.append("blocks", blocks.join(","));
  }

  const response = await buildHttpResponse({
    endPoint: `data/getCAGSlotwiseMetrics?${queryParams.toString()}`,
    method: HttpMethod.GET,
  });
  return response;
}

export async function getCAGDateWiseMetrics(
  ranges: { startDate: string; endDate: string }[],
  states: string[],
): Promise<any> {
  const queryParams = new URLSearchParams();
  queryParams.append("ranges", JSON.stringify(ranges));
  if (states && states.length > 0) {
    queryParams.append("state", states.join(","));
  }

  const response = await buildHttpResponse({
    endPoint: `data/getCAGDateWiseMetrics?${queryParams.toString()}`,
    method: HttpMethod.GET,
  });
  return response;
}
